import { Button, Fade, Grid, IconButton, Tooltip } from "@mui/material";
import PropTypes from "prop-types";

import { useUserData } from "src/context/userContext";
import { allowSwitchBetoniOrder } from "src/data/ifs/allowIfs";
import { SwitchVerticalIcon } from "src/components/icons/SwitchVerticalIcon";
import { keikkaBetoni_switchBetoniOrder } from "src/data/betoni/KeikkaBetoniFunctions";

import IconsContainer from "src/components/icons/others/IconsContainer";
import MyDivider from "src/components/layout/MyDivider";
import { DeleteIcon } from "src/components/icons/ActionIcons";
import { lazy } from "react";
import LazyLoader from "src/components/layout/Progress/LazyLoader";

const BetoniInfoBox = lazy(() => import("src/components/betoni/BetoniInfoBox/BetoniInfoBox"));

const styles = {
  div1: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "13px",
    height: "100%",
    alignItems: "center",
  },
};

export default function BetoniRow(props) {
  const keikkaBetoniId = props.keikkaBetoniId;
  const keikkaData = props.keikkaData;
  const { user, token, socket } = useUserData();
  const betoni = keikkaData.getBetoni(props.keikkaBetoniId);

  if (!user) return <div></div>;

  const betoniErrorToolTip = () => {
    if (keikkaData.tila.keikkaTilaId > 5) return "";
    else return betoni.betoniError(keikkaData.tila.keikkaTilaId < 4) || "";
  };
  const deleteBetoni = async (e) => {
    e.stopPropagation();
    if (!betoni) {
      console.log("NO BETONI!!");
      return;
    }
    const keikkaBetoniId = props.keikkaBetoniId;
    // remove betoni from keikkaData.betoni array
    keikkaData.betoni = keikkaData.betoni.filter((b) => b.keikkaBetoniId !== keikkaBetoniId);
    props.setKeikkaData(keikkaData);
    await deleteBetoni(keikkaBetoniId, token, socket, keikkaData.keikkaId);
    props.setKeikkaData(keikkaData);
  };

  const showDeleteBetoni =
    keikkaData.betoni.length > 1 && keikkaData.auth.edit && keikkaData.getBetoni(keikkaBetoniId);

  const renderDeleteBetoniIconButton = showDeleteBetoni && (
    <div className="noPrint" style={{ height: "100%" }}>
      <div style={styles.div1}>
        <Tooltip disableInteractive title="Poista tämä betoni" placement="top-end" arrow>
          <IconButton onClick={deleteBetoni} aria-label="Poista betoni" component="div">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );

  const switchBetonit = async () => {
    const _index = keikkaData.betoni.findIndex(
      (b) => b.keikkaBetoniId === keikkaData.getBetoni(keikkaBetoniId).keikkaBetoniId
    );
    const keikkaBetoniId1 = keikkaData.betoni[_index - 1].keikkaBetoniId;
    const keikkaBetoniId2 = keikkaData.getBetoni(keikkaBetoniId).keikkaBetoniId;
    const index1 = _index - 1;
    const index2 = _index;

    // switch betoni order in keikkaData.betoni array
    const temp1 = keikkaData.betoni[index1].orderNo;
    keikkaData.betoni[index1].orderNo = keikkaData.betoni[index2].orderNo;
    keikkaData.betoni[index2].orderNo = temp1;
    const temp2 = keikkaData.betoni[index1];
    keikkaData.betoni[index1] = keikkaData.betoni[index2];
    keikkaData.betoni[index2] = temp2;

    props.setKeikkaData(keikkaData);

    await keikkaBetoni_switchBetoniOrder(
      keikkaData.keikkaId,
      keikkaBetoniId1,
      keikkaBetoniId2,
      token,
      socket,
      user.personId
    );
  };

  const isError = keikkaData.auth.edit && betoniErrorToolTip() != "";

  return (
    <div
      style={{
        padding: isError ? "10px" : "0px",
        transition: "all 0.6s ease-in-out",
      }}>
      {props.bIndex > 0 && (
        <div style={{ paddingRight: "10%", paddingLeft: "10%" }}>
          <MyDivider>
            {allowSwitchBetoniOrder(betoni, keikkaData) && (
              <div className="noPrint">
                <Button variant="outlined" onClick={switchBetonit}>
                  <SwitchVerticalIcon />
                </Button>
              </div>
            )}
          </MyDivider>
        </div>
      )}
      <Tooltip disableInteractive title={betoniErrorToolTip()} placement="top-end" arrow>
        <Button
          variant={keikkaData.auth.edit && betoniErrorToolTip() != "" ? "outlined" : "text"}
          fullWidth
          onClick={() => props.onClick(betoni)}
          aria-label="Valitse betonitoimittaja"
          sx={{
            minHeight: "40px",
            margin: 0,
            padding: 0,
          }}>
          <Grid container className="stepRow" sx={{ width: "100%" }}>
            <Grid size={{ xs: 3 }} sx={{ textAlign: "right" }}>
              {/* {keikkaData.betoniToimittaja.asiakasId == 0 && (
                <Typography
                  variant="h6"
                  sx={{ paddingRight: "5px" }}
                  color="primary"
                  noWrap
                  className="fixPrint">
                  Betoni:
                </Typography>
              )} */}
              {renderDeleteBetoniIconButton}
            </Grid>
            <Grid size={{ xs: 8 }} sx={{ textAlign: "left" }}>
              <LazyLoader>
                <BetoniInfoBox betoni={betoni} keikkaData={keikkaData} />
              </LazyLoader>
            </Grid>

            {!keikkaData.isLoading && (
              <Fade in={true} timeout={500}>
                <Grid
                  size={{ xs: 1 }}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    paddingRight: "9px",
                  }}>
                  <IconsContainer
                    showWarning={betoniErrorToolTip() != ""}
                    showEdit={!props.disabled}
                    editOpacity={0.5}
                  />
                </Grid>
              </Fade>
            )}
          </Grid>
        </Button>
      </Tooltip>
    </div>
  );
}

BetoniRow.propTypes = {
  keikkaBetoniId: PropTypes.number,
  keikkaData: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  setKeikkaData: PropTypes.func,
  bIndex: PropTypes.number,
};
